import { DeliveryForecastDespatchAdvice } from '../../../../data/models'
import { calculatePackagingQuantity } from '../../../../utils/deliveryforecast-despatchadvice/calculatePackagedQuantity'

export enum PackagedQuantityState {
  None = 'none',
  Low = 'low',
  Match = 'match',
  High = 'high',
}

export type PackagedQuantityValidationResult = {
  isValid: boolean
  requestedQuantity: number
  packagedQuantity: number
  packagedQuantityState: PackagedQuantityState
}

export function validatePackagedQuantity(
  deliveryForecastDespatchAdvice?: DeliveryForecastDespatchAdvice,
): PackagedQuantityValidationResult | null {
  if (!deliveryForecastDespatchAdvice)
    return {
      isValid: false,
      packagedQuantity: 0,
      packagedQuantityState: PackagedQuantityState.None,
      requestedQuantity: 0,
    }

  const requestedQuantity =
    deliveryForecastDespatchAdvice.Items[0].ConfirmationQuantity

  const packaging = deliveryForecastDespatchAdvice.Packaging

  if (!packaging || packaging.length < 1)
    return {
      isValid: true,
      requestedQuantity,
      packagedQuantity: 0,
      packagedQuantityState: PackagedQuantityState.None,
    }

  const packagedQuantity = calculatePackagingQuantity(packaging[0]) || 0

  const packagedQuantityState = packagedQuantityStateFromValues(
    requestedQuantity,
    packagedQuantity,
  )

  return {
    isValid:
      packagedQuantityState === PackagedQuantityState.Match ? true : false,
    requestedQuantity,
    packagedQuantity,
    packagedQuantityState,
  }
}

function packagedQuantityStateFromValues(
  requestedQuantity: number,
  packagedQuantity: number,
): PackagedQuantityState {
  const diff = (requestedQuantity || 0) - (packagedQuantity || 0)

  if (diff === 0) return PackagedQuantityState.Match
  if (diff < 0) return PackagedQuantityState.High
  if (diff > 0) return PackagedQuantityState.Low

  return PackagedQuantityState.None
}
